export default {
  1: { xs: 24 },
  2: { xs: 24, sm: 12 },
  3: { xs: 24, sm: 12, md: 8 },
  4: { xs: 24, sm: 12, md: 6 },
};



// WEBPACK FOOTER //
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/DescriptionList/responsive.js